import { copyDeep } from '@/shared'
import { IStateStoreAnnouncementAdvisor } from '@/modules/advisor/modules/announcement/shared/@types'
import { HttpStatusCode, TypeNotify } from '@/shared/enums'
import { NotificationCustom } from '@/shared/function'
import AnnounceGuestService from '@/modules/guest/modules/announcement/services'

export const defaultStateAnnouncementAdvisor: IStateStoreAnnouncementAdvisor = {
    data: {}
}

const state = () => copyDeep(defaultStateAnnouncementAdvisor)

const getters = {
    getDataAnnouncementGuest(state: IStateStoreAnnouncementAdvisor) {
        return state.data
    }
}

const mutations = {
    setDataAnnouncementGuest(
        state: IStateStoreAnnouncementAdvisor,
        payload: any
    ) {
        state.data = payload
    }
}

const actions = {
    async getListDataAnnouncementGuest({ commit }: any, payload: any) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceGuestService.apiGetListAnnouncements(
                payload
            )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                commit('setDataAnnouncementGuest', data.data)
                return
            }
        } catch (error) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    },
    async getDetailAnnouncementGuest({ commit }: any, payload: any) {
        commit('popup/setLoading', true, { root: true })
        try {
            const res = await AnnounceGuestService.apiGetDetailAnnouncement(
                payload
            )
            const { status, data } = res
            if (status === HttpStatusCode.ok) {
                commit('setDataAnnouncementGuest', data.data)
                return
            }
            NotificationCustom({
                type: TypeNotify.error,
                message: data.errors.error_message
            })
        } catch (error) {
        } finally {
            commit('popup/setLoading', false, { root: true })
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
